const activateTixerInvitationOnClick = () => {

$(document).ready(function(){
  // $(".checkbox-tixer").click(function(){
  //   $(".tixer-choice").toggleClass("active");
  // });
  $(".checkbox-tixer").click(function(){
    $(".table-view-bottom").removeClass("invisible");
  });
});

}

export { activateTixerInvitationOnClick };
